import { render, staticRenderFns } from "./VideoSubNav.vue?vue&type=template&id=9546d5b8&scoped=true&"
import script from "./VideoSubNav.vue?vue&type=script&lang=js&"
export * from "./VideoSubNav.vue?vue&type=script&lang=js&"
import style0 from "./VideoSubNav.vue?vue&type=style&index=0&id=9546d5b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9546d5b8",
  null
  
)

export default component.exports